import type { TrackingLabels } from "../tracking/TrackingLabels";
import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import { Facet } from "./Facet";
import { events } from "../events";

const POPULAR_FACET_VALUES_WRAPPER_CLASS = "hc_facetValueGroup--unselectedPopular";

export class SveltePopularFacetValuesWrapper {
  static readonly factory: HeurekaElementFactory<SveltePopularFacetValuesWrapper, keyof HTMLElementTagNameMap> =
    HeurekaElementFactory.byClass(POPULAR_FACET_VALUES_WRAPPER_CLASS, SveltePopularFacetValuesWrapper);

  /*               */
  constructor(readonly popularFacetValuesWrapper: HTMLElement) {}

  public initialize() {
    this.facet.filter?.toggleInlineMode(true);
    return this;
  }

  get facet() {
    return Facet.factory.closest(this.popularFacetValuesWrapper);
  }

  get sanPopularFacetValues(): TrackingLabels["san_PopularFacetValues"] | undefined {
    const facet = this.facet;
    if (facet && !facet.hidden) {
      return facet.facet.name;
    }
  }
}

function onFilterSectionLoaded() {
  SveltePopularFacetValuesWrapper.factory.all().forEach((wrapper) => wrapper.initialize());
}

export function registerSveltePopularFacetValuesListeners() {
  events.onFilterSectionLoaded(onFilterSectionLoaded);
}
